import React, {Component} from 'react';
import { Link } from 'react-router-dom';
import ReactHtmlParser from 'react-html-parser';
import {children_diseases} from '../constants';
import Modal from "./Modal";
// import {
//   Button,
//   Modal,
//   ModalHeader,
//   ModalBody,
//   ModalFooter,
//   Form,
//   FormGroup,
//   Input,
//   Label
// } from "reactstrap";
import '../styles/bmi.css';


export const BmiResults = class Form extends Component {
  constructor() {
    super();
    this.state = {
      desease: false,
      save: false,
      n_advice: true,
      next: true,
      sickYes: false,
      sickNo: false,
      modal: false
    }
  }

  // onChange = (e) => {
  //   const state = this.state
  //   state[e.target.name] = e.target.value;
  //   this.setState(state);
  // }

  isSick = (e) => {
    const state = this.state
    let { name, value } = e.target;
    if (e.target.type === "checkbox") {
      value = e.target.checked;
    }
    if (e.target.type === "checkbox") {
      value = e.target.checked;
    }

    state[name] = value;

    if(name === "sickYes")
      state.sickNo = false;
    else
      state.sickYes = false;

    this.setState(state);

  }

  toggle = () => {
    this.setState({ modal: !this.state.modal });
  };

  toFeeding = () => {
    this.props.history.push("/dashboard/feeding/feeding-practice/")
  };

  componentDidMount() {

  }

  render() {
    const translation = this.props.Translator;
    const { message, warning, problem, Child } = this.props;
    const lang_sw = translation['language'] == 'swahili' ? true : false;
    return (
      <div className="col-md-12 col-sm-12 col-12" style={{padding: "0px 0px"}}>
        <div id="bmi_result" style={{fontSize: "0.8em"}}>
          <div>
            <div style={{marginTop: "0px",borderRadius: "0px",backgroundColor: "hsl(120, 50%, 40%)"}}>
              <div className="card-header">
                <div className="card-title text-center">{ReactHtmlParser(warning)}</div>
              </div>
              <div className="modal-body">
                <div className="bmi_message text-center" style={{background: "#fff",padding: "10px",margin: "10px 50px",borderRadius: "4px"}}>
                  {ReactHtmlParser(problem)}
                </div>
                <div className="container-fluid" style={{padding: "0px"}}>
                  <div id="sick" className="row">
                    <div className="col-md-12 col-sm-12 col-12">
                      <div className="form-group row">
                        <label className="form-control-label col-5 col-sm-5 col-md-5"  style={{padding: "5px 0px",textAlign: "right"}}>{translation['metrics_warning_is_sick_question_a']} {Child.first_name} {translation['metrics_warning_is_sick_question_b']}</label>
                        <div className="col-3 col-sm-3 col-md-3" style={{paddingTop:"10px"}}><input type="checkbox" name = "sickYes"  checked={this.state.sickYes} id="sickYes" onChange={this.isSick} /> <i>{translation['yes_option']}</i></div>
                        <div className="col-3 col-sm-3 col-md-3" style={{paddingTop:"10px"}}><input type="checkbox" name="sickNo"  checked={this.state.sickNo} id="sickNo" onChange={this.isSick} /><i>{translation['no_option']}</i></div>
                      </div>
                    </div>
                  </div>
                  {this.state.sickYes ? (
                  <div className="row" id="disease">
                    <div className="col-10 offset-1">
                      <div className="form-group">

                        <select className="form-control" style={{borderRadius: "0px",backgroundColor: "#d3d3d3"}}><option>{translation['metrics_warning_empty_option']}</option>
                          
                          {children_diseases.map((desease) => (
                            lang_sw ? (
                              <option value={desease['children_disease_id']}>{desease['disease_name_swahili']}</option>
                            ) : (
                              <option value={desease['children_disease_id']}>{desease['disease_name']}</option>
                            )
                          ))}
                          
                        </select>

                      </div>
                    </div>
                  </div>
                  ) : null}
                </div>
                {this.state.sickNo ? (<div id="n_advice" style={{textAlign: "center"}} className="p" style={{textAlign: "center"}}>{translation['metrics_warning_footer']}</div>) : null}
              </div>
              <div className="modal-footer">
                <button  data-dismiss="modal" style={{marginRight: "20px",height: "30px",width: "70px"}}>{translation['metrics_warning_cancel_button']}</button>
                {this.state.sickNo ? (<Link to={`${process.env.PUBLIC_URL}/dashboard/feeding/feeding-practice/`}><button style={{height: "30px",width: "90px",float: "right",marginRight: "10px"}} id="next">{translation['metrics_warning_next_button']}</button></Link>) : null }
                {this.state.sickYes ? (<button onClick = {this.toggle} style={{height: "30px",width: "70px",float: "right"}} id="save" data-toggle="modal" data-target="#sick_message">{translation['metrics_warning_save_button']}</button>) : null }
              </div>
            </div>
          </div>
      
        </div>

        <div className="modal" id="sick_message">
          <div className="modal-dialog">
            <div className="col-md-12 col-sm-12 col-xs-12">
              <div className="modal-content alert alert-warning" style={{marginTop: "195px",borderRadius: "0px"}}>
                <div className="modal-body ">
                  <p style={{color: "red",fontSize: "1.2em",fontWeight: "bolder"}}>{translation['metrics_warning_illness_warning_a']} {Child.first_name} {translation['metrics_warning_illness_warning_b']}</p>
                  <h5>{translation['metrics_warning_illness_warning_instruction_a']} {Child.first_name} {translation['metrics_warning_illness_warning_instruction_b']}</h5>
                </div>
                <div className="modal-footer">
                  <button type="button" onclick="toDashboard()" className="btn" style={{borderRadius: "0px",width: "90px",color: "#000"}}>{translation['metrics_warning_cancel_button']}</button>
                  <button type="button" className="btn" style={{borderRadius: "0px",width: "90px",color: "#000"}} id="Next">hey</button>
                </div>
              </div>
            </div>
          </div>
        </div>
        {this.state.modal ? (
        <Modal
          toggle={this.toggle}
          onSave={this.toFeeding}
          translation = {translation}
          Child = {Child}
        />
      ) : null}
      </div>
    );
  }
}

export default BmiResults;